import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';
import { fromStoreResultToStore } from '../../pages/BookAppointment/adapters/from-store-result-to-store.js';
import StoreFinderItem from '../StoreFinder/StoreFinderItem/StoreFinderItemContainer.js';

const PreferredStoreTile = ({ className , store , onClick  })=>/*#__PURE__*/ React.createElement(StoreFinderItem, {
        className: classnames('appointments-preferred-store-tile', className),
        store: swcHelpers.objectSpread({}, fromStoreResultToStore(store), {
            wheelchairAccessible: false,
            hearingAppointmentPossible: false
        }),
        variant: "list-item",
        icon: /*#__PURE__*/ React.createElement(Icon, {
            name: "store",
            width: 32,
            height: 32
        }),
        onClick: onClick
    })
;
var PreferredStoreTile$1 = PreferredStoreTile;

export { PreferredStoreTile$1 as default };
//# sourceMappingURL=PreferredStoreTile.js.map
